<template>
    <modal :show.sync="show" :on-close="close">
        <p class="modal-card-title" slot="title">Aesthetic options</p>
        <div slot="body">
            <div class="columns" v-for="index in range()" :key="index">
                <div class="column">
                    <a @click="updateAestheticOption(index)"><img :src="imageUrl[index]"></a>
                </div>
                <div class="column">
                    <a @click="updateAestheticOption(index+1)"><img :src="imageUrl[index+1]"></a>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
  import modal from './modal.vue'

  export default {
      components: {
          modal
      },
      props: ['show','aesthetic_option'],
      data: function() {
          return {
              imageUrl: [ 'images/AC1.jpg',
                          'images/AC2.jpg',
                          'images/AC3.jpg',
                          'images/AC4.jpg',
                          'images/AC5.jpg',
                          'images/AC6.jpg',
                          'images/AC7.jpg',
                          'images/AC8.jpg',
                          'images/AC9.jpg',
                          'images/AC10.jpg' ]
          }
      },
      methods: {
          close: function () {
            this.$emit('update:show', false)
          },
          updateAestheticOption(i) {
              this.$emit('update:aesthetic_option', {id: i+1, text: i+1})
              this.$emit('update:show', false)
          },
          range: function() {
              return [0, 2, 4, 6, 8]
          }
      }
  }
</script>
